import { useContext } from 'react'

import { NotchContext } from './notch-provider'

export const useNotchContext = () => {
  const notchContext = useContext(NotchContext)
  if (notchContext === undefined) {
    throw new Error('useNotchContext must be used within a NotchProvider')
  }
  return notchContext
}
